import { commitAction } from '../actions/commit'
import { commitMutation } from '../mutations/commit'

export const commit = {
  state: {
    'person/code': {
      data: {}
    },
    'payfor/free': {
      data: {}
    },
    'payfor/wxpay': {
      data: {}
    },
    'zmxy/auth': {
      data: {}
    },
    'share/success': {
      data: {}
    },
    'zmxy/supplement': {
      data: {}
    },
    'person/changepw': {
      data: {}
    },
    'person/sumbitpw': {
      data: {}
    }
  },
  mutations: commitMutation,
  actions: commitAction
}



// WEBPACK FOOTER //
// ./src/store/modules/commit.js